<template>
  <div class="o-card">
    <form @submit="TO_FORGET_PASSWORD">
      <div class="u-margin-bottom">
        <router-link :to="{ name: 'app-start' }">
          <logo width="80"></logo>
        </router-link>
        <h6 class="u-margin-top u-color-primary">
          {{ $t("common.welcome") }},
        </h6>
        <h4>{{ getAppSettings.projectName }}</h4>
        <p class="u-font-size-small">
          <small> {{ $t("account.signIn.forgotPasswordTitle") }}.. </small>
        </p>
      </div>
      <div v-if="localStorageEmail" class="">
        <div
          class="u-display-flex u-align-items-center u-padding-xsmall u-border u-radius-g"
        >
          <i class="icofont-email u-font-size-large"></i>
          <span class="u-margin-left-small">{{ localStorageEmail }}</span>
        </div>
        <div class="u-text-align-right">
          <a @click="CHANGE_EMAIL()" href="javascript:void(0)">
            <small>
              <i> {{ $t("account.signIn.changeEmail") }}</i>
            </small>
          </a>
        </div>
      </div>
      <BaseInput
        v-else
        mandatory
        :label="$t('account.signIn.email')"
        input-id="email"
        icon="email"
        :placeholder="$t('account.signIn.emailPlaceholder')"
        block
        v-model="form.email"
      />
      <Button
        class="u-margin-top"
        :loading="getLoadingStatus"
        block
        variant="primary"
        type="submit"
      >
        {{ $t("account.signIn.resetPassword") }}
      </Button>
    </form>
  </div>
</template>

<script>
import BaseInput from "@base/Inputs/BaseInput.vue";
import Button from "@base/Button.vue";
import GeneralStore from "../../mixins/generalStore";
import { mapGetters } from "vuex";
import Logo from "../Shared/Sidebar/Logo.vue";
export default {
  mixins: [GeneralStore],
  components: {
    BaseInput,
    Button,
    Logo,
  },
  computed: {
    ...mapGetters(["getAppSettings"]),
  },
  data() {
    return {
      localStorageEmail: null,
      form: {
        email: "",
      },
    };
  },
  methods: {
    getEmailFromLocalstorage() {
      const email = localStorage.getItem("email") || null;
      if (email) this.form.email = email;
      return email;
    },
    CHANGE_EMAIL() {
      localStorage.removeItem("email");
      this.localStorageEmail = null;
      this.form.email = "";
      document.getElementById("email").focus();
    },
    async TO_FORGET_PASSWORD(e) {
      e.preventDefault();
      const response = await this.$store.dispatch("TO_FORGET_PASSWORD", {
        email: this.form.email,
        language: this.$i18n.locale,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("account.signIn.resetPasswordSuccess"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
    },
  },
  created() {
    this.storeNamespace = "account";
    this.localStorageEmail = this.getEmailFromLocalstorage();
  },
};
</script>

<style></style>
